import { SceneData } from '@/schemas/sceneDataSchema';
import { useSceneStore } from './scene-store';
import { useQuoteStore } from '@/hooks/quote/use-quote-store';

function hydrateQuote(stepData: NonNullable<SceneData['step_state']>) {
  const { coverages, price_data } = stepData;
  if (coverages || price_data) {
    useQuoteStore.getState().hydrateFromStepData(coverages ?? null, price_data ?? null);
  }
}

export function applyStepData(stepData?: SceneData['step_state']) {
  if (!stepData) return;
  if (stepData.scene_data) {
    useSceneStore.getState().applySceneData(stepData.scene_data);
  }
  hydrateQuote(stepData);
}

export function mergeStepData(stepData?: SceneData['step_state']) {
  if (!stepData) return;
  if (stepData.scene_data) {
    // Merge returned fields without clearing any pending changes.
    useSceneStore.getState().mergeSceneData(stepData.scene_data, []);
  }
  hydrateQuote(stepData);
}

export function applyPersistData(stepData: SceneData['step_state'], persistedKeys: string[]) {
  if (!stepData) return;
  if (stepData.scene_data) {
    useSceneStore.getState().mergeSceneData(stepData.scene_data, persistedKeys);
  }
  hydrateQuote(stepData);
}
